import React from "react";
import { OrderMetricsChartCard } from "./CustomOrderChartCard";
import { mergeRepairOrderModel } from "./dashboardChartsModel";

/**
 * Repair Order — same chart + table + kebab as Custom Order; distinct demo/API series via {@link mergeRepairOrderModel}.
 *
 * @param {object} props
 * @param {import("./dashboardChartsModel.js").CustomOrderChartModel | undefined} [props.model]
 * @param {() => void} [props.onMenuRemove]
 */
function RepairOrderChartCard({ model, onMenuRemove }) {
  return (
    <OrderMetricsChartCard
      model={model}
      onMenuRemove={onMenuRemove}
      mergeModel={mergeRepairOrderModel}
      titleKey="graphRepairOrder"
      defaultTitle="Repair Order"
      downloadPrefix="repair-order"
      rowIdPrefix="ro"
    />
  );
}

export default RepairOrderChartCard;
